import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';

import {SaveUserMutation, SaveUserMutationConfig} from '../qql-shared/mutations';
import {User} from '../qql-shared/fragments';
import UserForm from '../components/UserForm';
import {UsersQuery} from './UsersPage';

const UserQuery = gql`
  query user($_id: String!) {
    user(_id: $_id) {
      ...User
    }
    allClients {
      _id
      name
    }
    allEmployees {
      _id
      name
    }
  }
  ${User}
`;

const UserQueryConfig = {
  options: ({match}) => ({variables: {_id: match.params.id}, fetchPolicy: 'cache-and-network'}),
};

const GenerateNewLoginTokenMutation = gql`
  mutation generateNewLoginToken($_id: String) {
    generateNewLoginToken(_id: $_id) {
      ...User
    }
  }
  ${User}
`;

const GenerateNewLoginTokenMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    generateNewLoginToken: () => mutate({variables: {_id}}),
  }),
};

const RemoveUserMutation = gql`
  mutation removeUser($_id: String!) {
    removeUser(_id: $_id) {
      userRemoved
      logsRemoved
      directoryRemoved
      userExisted
    }
  }
`;

const RemoveUserMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    removeUser: () =>
      mutate({
        variables: {_id},
        update: (
          store,
          {
            data: {
              removeUser: {userRemoved},
            },
          }
        ) => {
          if (!userRemoved) return;
          const data = store.readQuery({query: UsersQuery});
          data.allUsers = data.allUsers.filter(user => user._id !== _id);
          store.writeQuery({query: UsersQuery, data});
        },
      }),
  }),
};

export default compose(
  graphql(RemoveUserMutation, RemoveUserMutationConfig),
  graphql(GenerateNewLoginTokenMutation, GenerateNewLoginTokenMutationConfig),
  graphql(SaveUserMutation, SaveUserMutationConfig),
  graphql(UserQuery, UserQueryConfig)
)(UserForm);



// WEBPACK FOOTER //
// ./src/containers/UserEdit.js